module.exports = __webpack_public_path__ + "img/reference-jukas.36ae24c8.webp";